export default __webpack_public_path__ + "static/media/adminSessionWall.40ce4ca5.png";